export default __webpack_public_path__ + "static/media/G0760.34I-32543_-17836_0.1654023360000.c4936ce1.jpg";